module.exports = __webpack_public_path__ + "img/6.01ac1ed8.jpg";